// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprTitle extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.title";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprTitle {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "La teva privacitat és important per a nosaltres",
                "cs": "Vaše soukromí je pro nás důležité",
                "da": "Dit privatliv er vigtigt for os",
                "de": "Ihre Privatsphäre ist uns wichtig",
                "en": "Your privacy is important to us",
                "es": "Tu privacidad es importante para nosotros",
                "eu": "Zure pribatutasuna garrantzitsua da guretzat",
                "fi": "Yksityisyytesi on meille tärkeää",
                "fr": "Votre vie privée est importante pour nous",
                "gl": "A túa privacidade é importante para nós",
                "hi": "आपकी निजता हमारे लिए महत्वपूर्ण है",
                "hu": "Az Ön adatainak védelme fontos számunkra",
                "it": "La tua privacy è importante per noi",
                "nl": "Jouw privacy is belangrijk voor ons",
                "no": "Ditt personvern er viktig for oss",
                "pl": "Twoja prywatność jest dla nas bardzo ważna.",
                "pt": "A sua privacidade é importante para nós",
                "ro": "Confidențialitatea dvs. este importantă pentru noi",
                "ru": "Ваша конфиденциальность важна для нас",
                "sk": "Vaše súkromie je pre nás dôležité",
                "sv": "Din integritet är viktig för oss",
                "pt-BR": "Sua privacidade é importante para nós"
            }
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
